import script from "./RegisterHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterHeader.vue?vue&type=script&setup=true&lang=js"

import "./RegisterHeader.vue?vue&type=style&index=0&id=a019d500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a019d500"]])

export default __exports__